import { EnumSchema, Executor, FromSchema } from '@40seas/entities/common';
import { BaseEntity, Currency, PaymentMethodType, WithBaseEntitySchema } from '@40seas/models';
import { z } from 'zod';
import { ConnectedAccountKybStatus } from './connected-account.kyb.status.enum';
import { ConnectedAccountStatus } from './connected-account.status.enum';
import { ConnectedAccountTransactionRfiStatus } from './connected-account.transaction.rfi.status.enum';
import { ProviderType } from './provider.type.enum';

export const ConnectedAccountSchema = WithBaseEntitySchema(
    z.object({
        providerType: EnumSchema(ProviderType),
        status: EnumSchema(ConnectedAccountStatus),
        kybStatus: EnumSchema(ConnectedAccountKybStatus).optional(),
        transactionRfiStatus: EnumSchema(ConnectedAccountTransactionRfiStatus).optional(),
        providerId: z.string(),
        enabledPaymentMethods: z.array(EnumSchema(PaymentMethodType)).optional(),
        supportedCurrencies: z.array(EnumSchema(Currency)).optional(),
        capabilitiesIds: z.array(z.string()).optional(),
    }),
).strict();

export class ConnectedAccount extends FromSchema(ConnectedAccountSchema) implements BaseEntity {
    id: string;
    providerId: string;
    providerType: ProviderType;
    status: ConnectedAccountStatus;
    kybStatus?: ConnectedAccountKybStatus;
    transactionRfiStatus?: ConnectedAccountTransactionRfiStatus;
    enabledPaymentMethods?: PaymentMethodType[];
    supportedCurrencies?: Currency[];
    capabilitiesIds?: string[];
    createdAt: Date;
    updatedAt: Date;
    tenantId: string;
    seller?: string;
    createdBy: Executor;
    metadata?: { [key: string]: string };
    timeline?: { [status: string]: { updatedAt: Date } };
}

export const connectedAccountStatusMapper = new Map<string, ConnectedAccountStatus>([
    ['CREATED', ConnectedAccountStatus.Pending],
    ['SUBMITTED', ConnectedAccountStatus.Submitted],
    ['ACTION_REQUIRED', ConnectedAccountStatus.ActionRequired],
    ['ACTIVE', ConnectedAccountStatus.Active],
    ['SUSPENDED', ConnectedAccountStatus.Suspended],
]);
